/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPayorFieldCondition } from './HchbPayorFieldCondition';
import {
    HchbPayorFieldConditionFromJSON,
    HchbPayorFieldConditionFromJSONTyped,
    HchbPayorFieldConditionToJSON,
    HchbPayorFieldConditionToJSONTyped,
} from './HchbPayorFieldCondition';
import type { HchbPayorFormFieldOptionsInner } from './HchbPayorFormFieldOptionsInner';
import {
    HchbPayorFormFieldOptionsInnerFromJSON,
    HchbPayorFormFieldOptionsInnerFromJSONTyped,
    HchbPayorFormFieldOptionsInnerToJSON,
    HchbPayorFormFieldOptionsInnerToJSONTyped,
} from './HchbPayorFormFieldOptionsInner';

/**
 * 
 * @export
 * @interface HchbPayorFormField
 */
export interface HchbPayorFormField {
    /**
     * 
     */
    key: string;
    /**
     * 
     */
    label: string;
    /**
     * 
     */
    type: HchbPayorFormFieldTypeEnum;
    /**
     * 
     */
    required?: boolean;
    /**
     * 
     */
    editable?: boolean;
    /**
     * Configured initial value (string, number, boolean, or null). Immutable for read-only fields; otherwise used only when no draft value exists.
     */
    value?: any | null;
    /**
     * For zip_city and zip_state, the key of the zip field whose lookup supplies the options.
     */
    zip_field?: string;
    /**
     * 
     */
    options?: Array<HchbPayorFormFieldOptionsInner>;
    /**
     * 
     */
    visible_when?: HchbPayorFieldCondition;
    /**
     * 
     */
    required_when?: HchbPayorFieldCondition;
}


/**
 * @export
 */
export const HchbPayorFormFieldTypeEnum = {
    Text: 'text',
    Date: 'date',
    Number: 'number',
    Checkbox: 'checkbox',
    Select: 'select',
    Radio: 'radio',
    ZipCity: 'zip_city',
    ZipState: 'zip_state',
} as const;
export type HchbPayorFormFieldTypeEnum = typeof HchbPayorFormFieldTypeEnum[keyof typeof HchbPayorFormFieldTypeEnum];


/**
 * Check if a given object implements the HchbPayorFormField interface.
 */
export function instanceOfHchbPayorFormField(value: object): value is HchbPayorFormField {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function HchbPayorFormFieldFromJSON(json: any): HchbPayorFormField {
    return HchbPayorFormFieldFromJSONTyped(json, false);
}

export function HchbPayorFormFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorFormField {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'type': json['type'],
        'required': json['required'] == null ? undefined : json['required'],
        'editable': json['editable'] == null ? undefined : json['editable'],
        'value': json['value'] === undefined ? undefined : json['value'] === null ? null : json['value'],
        'zip_field': json['zip_field'] == null ? undefined : json['zip_field'],
        'options': json['options'] == null ? undefined : ((json['options'] as Array<any>).map(HchbPayorFormFieldOptionsInnerFromJSON)),
        'visible_when': json['visible_when'] == null ? undefined : HchbPayorFieldConditionFromJSON(json['visible_when']),
        'required_when': json['required_when'] == null ? undefined : HchbPayorFieldConditionFromJSON(json['required_when']),
    };
}

export function HchbPayorFormFieldToJSON(json: any): HchbPayorFormField {
    return HchbPayorFormFieldToJSONTyped(json, false);
}

export function HchbPayorFormFieldToJSONTyped(value?: HchbPayorFormField | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'type': value['type'],
        'required': value['required'],
        'editable': value['editable'],
        'value': value['value'],
        'zip_field': value['zip_field'],
        'options': value['options'] == null ? undefined : ((value['options'] as Array<any>).map(HchbPayorFormFieldOptionsInnerToJSON)),
        'visible_when': HchbPayorFieldConditionToJSON(value['visible_when']),
        'required_when': HchbPayorFieldConditionToJSON(value['required_when']),
    };
}

